import { CollectionIcon, MainButton, MotionBox } from './UiElements';
import layoutStore from '../stores/layoutStore';
import { Tooltip } from '@chakra-ui/tooltip';
import { AnimatePresence, motion } from 'framer-motion';
import { tooltipAnimation, tooltipDownAnimation } from './customTheme';
import { Box, Button, Icon, Text, useColorModeValue } from '@chakra-ui/react';
import usePersistStore from '../stores/persistStore';
import useStore from '../stores/store';

const WorkspacePicker = ({ wsVariant = false }) => {
    if (wsVariant) return <WsInnerButton wsBg />;
    else
        return (
            <Tooltip
                motionProps={tooltipDownAnimation}
                label={
                    <Text>
                        Show workspaces
                        <span style={{ opacity: '0.5', marginLeft: '4px' }}>
                            ␣
                        </span>
                    </Text>
                }
                placement="top"
                rounded="6px"
                zIndex={1000}
                sx={{ transition: '0s' }}
            >
                <div /* layout={'position'} <- Prevent layout distortion */>
                    <WsInnerButton />
                </div>
            </Tooltip>
        );
};

export default WorkspacePicker;

export const WsInnerButton = ({ wsBg = false }) => {
    const hoverButton = useColorModeValue('gray.200', '#24272A');
    const wsHoverBg = useColorModeValue('gray.300', '#32363A');
    const activeButton = useColorModeValue('gray.300', '#32363A');

    const setWorkspaceZoom = layoutStore((state) => state.setWorkspaceZoom);
    const workspaceZoom = layoutStore((state) => state.workspaceZoom);
    const setIsZooming = layoutStore((state) => state.setIsZooming);
    const showWorkspaceEmoji = usePersistStore(
        (state) => state.showWorkspaceEmoji
    );

    const toggleWorkspaceZoom = () => {
        if (workspaceZoom === 'zoomed-out') {
            setWorkspaceZoom('zoomed-in');
            /* setIsZooming(true);
            setTimeout(() => {
                setIsZooming(false);
            }, 280); */
        } else {
            setWorkspaceZoom('zoomed-out');
            /* setIsZooming(true);
            setTimeout(() => {
                setIsZooming(false);
            }, 280); */
        }
    };

    return (
        <Button
            onClick={toggleWorkspaceZoom}
            size="sm"
            bg={'transparent'}
            //boxShadow={noBg ? '' : 'var(--chakra-colors-mainButtonShadow)'}
            _hover={{
                bg: wsBg ? wsHoverBg : hoverButton
            }}
            _active={{
                bg: /* wsBg ? hoverButton :  */ activeButton
            }}
            h="32px"
            w="32px"
            rounded="8px"
            p="0"
            alignItems={'center'}
            transition={'0.1s'}
            mr="8px"
        >
            {showWorkspaceEmoji ? (
                <WorkspaceEmoji />
            ) : (
                <Icon as={CollectionIcon} boxSize={2} />
            )}
        </Button>
    );
};

const WorkspaceEmoji = () => {
    const userData = useStore((state) => state.userData);
    const currentWsId = useStore((state) => state.currentWsId);
    const workspaces = userData?.workspaces;
    const currentWorkspace = workspaces?.find((ws) => ws.id === currentWsId);
    const currentEmoji = currentWorkspace?.emoji;
    const isImage = currentEmoji?.length > 10;

    if (!currentEmoji)
        return (
            <Box
                /* as={motion.div}
                initial={{ scale: 0 }}
                animate={{ scale: 1 }} */
                h="20px"
                w="20px"
                rounded="6px"
                bg={'skeletonBg'}
            />
        );
    else if (isImage) {
        return (
            <img
                src={currentEmoji}
                style={{ width: '24px', height: '24px', borderRadius: '4px' }}
            />
        );
    }
    return <Text fontSize="16px">{currentEmoji}</Text>;
};
